import { render, staticRenderFns } from "./detail-content.vue?vue&type=template&id=25742725&lang=pug&"
import script from "./detail-content.vue?vue&type=script&lang=js&"
export * from "./detail-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports